import React from "react";
import { useTranslation } from "react-i18next";

function SpotifySection() {
  const { t } = useTranslation();

  return (
    <section className="nw-section" id="spotify">
      <div className="nw-section-head">
        <h2>{t("spotify.title")}</h2>
        <p>{t("spotify.comingSoon")}</p>
      </div>
      <div className="nw-spotify-card">
        <div className="nw-spotify-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="img" focusable="false">
            <path
              d="M12 0.8C5.9 0.8 0.8 5.9 0.8 12S5.9 23.2 12 23.2 23.2 18.1 23.2 12 18.1 0.8 12 0.8zm5.3 16.2c-.2.3-.6.4-.9.2-2.5-1.5-5.7-1.9-9.4-1.1-.4.1-.7-.2-.8-.5-.1-.4.2-.7.5-.8 4-.9 7.5-.5 10.3 1.3.4.2.4.6.3.9zm1.3-2.8c-.3.4-.8.5-1.2.2-2.9-1.8-7.3-2.3-10.6-1.3-.5.1-1-.1-1.1-.6-.1-.5.1-1 .6-1.1 3.9-1.2 8.7-.6 12.1 1.5.4.3.5.8.2 1.3zm.1-3c-3.4-2-9-2.2-12.3-1.2-.6.2-1.2-.1-1.4-.7-.2-.6.1-1.2.7-1.4 3.8-1.2 10.1-1 14 1.4.5.3.7 1 .4 1.5-.3.5-1 .7-1.5.4z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div>
          <h3>{t("spotify.cardTitle")}</h3>
          <p>{t("spotify.cardBody")}</p>
        </div>
      </div>
    </section>
  );
}

export default SpotifySection;
